import axios from 'client';
import * as dto from 'client/dto';

function getBepi(locationId: number, client = axios): Promise<dto.LocationBepiModel> {
  return client
    .get('/api/bepi', {
      params: {
        locationId,
      },
    })
    .then(({ data }) => data);
}

export default {
  getBepi,
};
